export enum SmartLinkDecisionAction {
  ACCEPT = 'accept',
  REJECT = 'reject',
}
